import styled from 'styled-components';
import * as UIConstants from '../../UIConstants'

export const Wrapper = styled.div`
width: 100%;
box-sizing: border-box;
`;

export const Container = styled.div`
width: 100%;
box-sizing: border-box;
display: flex;
flex-flow: column wrap;
align-items: flex-start;
justify-content: flex-start;
`;

export const DisableButton = styled.div`
font-weight:400;
${UIConstants.mobileView}{
    font-size:12px;
}
`
export const ModalWrapper=styled.div`
// width:100%;
padding:20px 50px 10px 50px;
`
export const ModalImg=styled.div`

`
export const ModalMessege=styled.h2`

`
export const ModalAction=styled.h2`
 display:flex;
 justify-content:flex-end;
 gap:5px;
`